/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeletePenaltyCommand } from '../../models/delete-penalty-command';
import { DeletePenaltyCommandResult } from '../../models/delete-penalty-command-result';

export interface ApiPenaltiesDeletePenaltyDelete$Params {
      body?: DeletePenaltyCommand
}

export function apiPenaltiesDeletePenaltyDelete(http: HttpClient, rootUrl: string, params?: ApiPenaltiesDeletePenaltyDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeletePenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltiesDeletePenaltyDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeletePenaltyCommandResult>;
    })
  );
}

apiPenaltiesDeletePenaltyDelete.PATH = '/api/Penalties/DeletePenalty';
